import ControlType from './ControlType';
import FormControl from './FormControl';

export default class CheckboxInput extends FormControl<HTMLInputElement> {
  type = ControlType.Checkbox;
}
